// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","trendingPanel":"_3XzILxful35pJx5QZuM-dM","loading":"Z3pFfJg9-B4x2TcE8YbxJ"};